<div class="container TopBar">
  <div class="row">
    <div class="col">
      <a
        (click)="backUrl()"
        class="BackSession"
        *ngIf="this.haveBack && this.hideBackButton"
      >
        <mat-icon aria-hidden="false" aria-label="arrow_back"
          >arrow_back</mat-icon
        >
      </a>
    </div>
    <div class="col text-center">
      <h5 class="d-none d-md-block d-lg-block">{{ TextoTopo }}</h5>
      <img
        src="../../../assets/image/logo-header-mobile.svg"
        class="d-md-none d-lg-none"
        alt=""
      />
    </div>
    <div class="col">
      <ng-container *ngIf="!hideMenu">
        <mat-icon class="BtnMenu" (click)="toggleDisplay()">menu</mat-icon>
        <div class="row">
          <div class="col">
            <div id="overlay" *ngIf="!isShow" (click)="toggleDisplay()"></div>
            <div class="BoxMenu" *ngIf="!isShow">
              <div class="HeaderMenu">
                <label>Menu</label>
                <mat-icon (click)="toggleDisplay()">close</mat-icon>
              </div>
              <ul class="MenuList">
                <li>
                  <a mat-menu-item routerLink="/contratos/meus-contratos"
                    >Meus contratos</a
                  >
                </li>
                <li>
                  <a mat-menu-item routerLink="/contratos"
                    >Fazer nova contratação</a
                  >
                </li>
                <li>
                  <a mat-menu-item (click)="redirectUpdate()">Meu cadastro</a>
                </li>
                <li>
                  <a mat-menu-item (click)="openDialogPrivacyPolicy()"
                    >Política de privacidade</a
                  >
                </li>
                <li>
                  <a mat-menu-item (click)="changePassword()"
                    >Alterar minha senha</a
                  >
                </li>
                <li>
                  <a mat-menu-item (click)="session.logout()">Sair</a>
                </li>
              </ul>
              <div class="d-flex align-items-center justify-content-center">
                <app-btn-whatsapp></app-btn-whatsapp>
              </div>
              <div class="BoxAtendimento" (click)="onPhoneButtonClick()">
                <p>
                  Central de Atendimento <br />
                  <b>0800 880 1900</b>
                </p>
              </div>
              <!-- <a (click)="session.logout()" class="BtnSair">Sair</a> -->
            </div>
          </div>
        </div>
      </ng-container>
      <ul class="d-none">
        <li>
          <div class="StatusEtapaOk">
            <mat-icon>done</mat-icon>
          </div>
          <a href="#"> Instituição pública </a>
        </li>
        <li>
          <div class="StatusEtapaOk">
            <mat-icon>done</mat-icon>
          </div>
          <a> Calculadora </a>
        </li>
        <li>
          <div class="StatusEtapaOk">
            <mat-icon>done</mat-icon>
          </div>
          <a href="#"> Resumo </a>
        </li>
        <li>
          <div class="StatusEtapaOk">
            <mat-icon>done</mat-icon>
          </div>
          <a href="#"> Dados </a>
        </li>
        <li>
          <div class="StatusEtapaPendente">
            <mat-icon>flag</mat-icon>
          </div>
          <a href="#"> Documentação </a>
          <span>Há 4 pendências</span>
        </li>
        <li>
          <div class="StatusEtapaAguardando">
            <mat-icon>query_builder</mat-icon>
          </div>
          <a href="#"> Foto </a>
          <span>Aguardando pendências</span>
        </li>
        <li>
          <div class="StatusEtapaAguardando">
            <mat-icon>query_builder</mat-icon>
          </div>
          <a href="#"> Contrato </a>
          <span>Aguardando pendências</span>
        </li>
      </ul>
    </div>
  </div>
</div>
